/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(element, selector) {
  var proto = Element.prototype;
  var vendor = proto.matches || proto.matchesSelector || proto.webkitMatchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector;
  function match(el, sel) {
    if (vendor) {
      return vendor.call(el, sel);
    }
    var nodes = el.parentNode.querySelectorAll(sel);
    for (var i = 0, len = nodes.length; i < len; i++) {
      if (nodes[i] == el) {
        return true;
      }
    }
    return false;
  }
  return match(element, selector);
};
exports.default = _default;